import React from 'react';
import './Chapters.scss';

function Chapter5() {
  return (
    <>
      <section className="chapter" style={{ marginBottom: '-1.5rem' }}>
        <p className="chapter__title">On the Road</p>
        <p className="chapter__paragraph">
          From the moment the Kumatoes<sup>®</sup> are harvested in Perfection Two Wells, a race
          against the clock begins. They must be packed, loaded, and processed at a distribution
          center. From there, the destinations can span hundreds or even thousands of miles. This is
          an especially perilous phase for perishable goods—unforeseen shipping delays, climate
          events, and labor fluctuations persistently threaten the timely delivery of a product
          whose very worth depends on a tightly managed schedule.
        </p>
        <p className="chapter__paragraph">
          To gain an edge in this battle against the unforeseen, Perfection must log and track an
          entirely different dataset, monitoring geolocation, temperature, and humidity both in
          real-time and at aggregate levels. This allows them to identify logistical challenges
          along the route like transportation bottlenecks and prolonged downtime that might affect
          product quality down the line.
        </p>
      </section>
    </>
  );
}

export default Chapter5;
